let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("dsiAd"), load("dczku")]).then(() => parcelRequire('7WItf'));